module.exports = "/assets/data/82202542a8a6c6b5e12554d06ba4169e-WD3.data.json";